<template>
  <a :href="wechatLoginUrl" @click="setRedirectUrlCookie">
    <img src="/static/img/oAuthLogin/wechat.png" alt="wechat" />
  </a>
</template>

<script>
import cookie from '../../../lib/cookie';
import { mapState } from 'vuex';

export default {
  name: 'wechat-login',
  data: function () {
    return {
      wechatLoginUrl: 'javascript:void(0)'
    };
  },
  computed: {
    redirectUrl() {
      return this.$store.state.redirectUrl;
    },
    ...mapState({
      clickIndexPagePackageData: state => state.clickIndexPagePackageData
    })
  },
  created() {
    this.loadWechatLoginUrl();
  },
  methods: {
    loadWechatLoginUrl() {
      this.$http.get('api/oauth-providers').then(response => {
        if (response.data.code !== 0) {
          return;
        }
        for (let loginInfo of response.body.data) {
          if (loginInfo.id === 'wechat') {
            this.wechatLoginUrl = loginInfo.redirect_url;
          }
        }
      });
    },
    setRedirectUrlCookie() {
      if (this.clickIndexPagePackageData) {
        localStorage.clickIndexPagePackageData = JSON.stringify(this.clickIndexPagePackageData);
      }
      if (this.redirectUrl !== '/dashboard') {
        cookie.setCookie('redirect_url', this.redirectUrl);
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../../assets/scss/variables';

a {
  display: inline;
  margin: 0;
  img {
    max-width: 0.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// WechatLogin.vue?ae12e536